<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-display">
        <div v-for="(repeat, index) in repeats" class="col-lg-4 col-md-5 col-sm-12 col-xs-12" :key="'repeat-' + index">
          <div v-if="repeat.image_link!==''">
            <a :href="repeat.image_link">
              <img id="textSectionImage" :src="repeat.image_src" class="text-image lazy">
            </a>
          </div>
          <div v-else>
            <img :src="repeat.image_src" class="text-image lazy">
          </div>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 headline">
            <div :style="{ '--color' : non_repeat.headline_color }" class="col-xs-12 col-md-12 headline_color">
            <p id="textSectionTitle" class="col-xs-12 text-headline" v-html="non_repeat.title"></p>
          </div>
          <div>
            <p id="textSectionDescription" class="col-xs-12 text-title" v-html="non_repeat.text"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TextSection",
  props: ['repeats', 'non_repeat'],
}
</script>

<style scoped>
.text-display{
  display: flex;
  justify-content: center;
  margin-bottom: 90px;
  margin-top: 60px;
}
.text-headline{
  font-family: "Open Sans";
  padding-left: 0;
}
.text-title{
  font-family: "Open Sans";
}
.text-image{
  margin-left: 25%;
  margin-top: 25px;
}
.headline{
  margin-right: 10%;
}
@media (max-width: 767px) {
  .text-display {
    display: block;
    margin-top: 27px;
  }
  .text-image{
    text-align: left;
    margin-left: 0;
    margin-bottom: 20px;
  }
  .text-headline{
    font-family: "Open Sans";
    margin-top: 0;
  }
  .text-title{
    font-family: "Open Sans";
  }
}
</style>
